var map = {
	"./": 5915,
	"./App": 4805,
	"./App.jsx": 4805,
	"./MsClient/authConfig": 4524,
	"./MsClient/authConfig.js": 4524,
	"./Pages/allorders": 4308,
	"./Pages/allorders.jsx": 4308,
	"./Pages/allvendors": 8799,
	"./Pages/allvendors.jsx": 8799,
	"./Pages/finance": 175,
	"./Pages/finance.jsx": 175,
	"./Pages/homePage": 7285,
	"./Pages/homePage.jsx": 7285,
	"./Pages/loginPage": 6071,
	"./Pages/loginPage.jsx": 6071,
	"./Pages/loginload": 3066,
	"./Pages/loginload.jsx": 3066,
	"./Pages/menuPage": 821,
	"./Pages/menuPage.jsx": 821,
	"./Pages/missing": 8329,
	"./Pages/missing.jsx": 8329,
	"./Pages/unauthorized": 6759,
	"./Pages/unauthorized.jsx": 6759,
	"./api/allAxios": 6278,
	"./api/allAxios.js": 6278,
	"./assets/Sidebar-logo.png": 3628,
	"./assets/images/Ashwini.jpg": 8840,
	"./assets/images/Dummatka.jpg": 9691,
	"./assets/images/Happysingh.jpg": 8622,
	"./assets/images/Havmor.jpg": 7838,
	"./assets/images/Home.jpg": 4010,
	"./assets/images/Home1.png": 6997,
	"./assets/images/Home2.png": 1246,
	"./assets/images/Kannu.jpg": 9070,
	"./assets/images/Letseat.jpg": 7451,
	"./assets/images/Moksh.jpg": 7661,
	"./assets/images/Oc.jpg": 4773,
	"./assets/images/Rochanos.jpg": 2260,
	"./assets/images/Vivekchats.jpg": 9871,
	"./assets/images/abCoffee.jpeg": 6447,
	"./assets/logo.png": 3153,
	"./components/ByUser": 1292,
	"./components/ByUser/": 1292,
	"./components/ByUser/index": 1292,
	"./components/ByUser/index.jsx": 1292,
	"./components/ByVendor": 3311,
	"./components/ByVendor/": 3311,
	"./components/ByVendor/index": 3311,
	"./components/ByVendor/index.jsx": 3311,
	"./components/Cart": 4081,
	"./components/Cart/": 4081,
	"./components/Cart/index": 4081,
	"./components/Cart/index.jsx": 4081,
	"./components/Filters": 8307,
	"./components/Filters/": 8307,
	"./components/Filters/index": 8307,
	"./components/Filters/index.jsx": 8307,
	"./components/Finance": 9227,
	"./components/Finance/": 9227,
	"./components/Finance/index": 9227,
	"./components/Finance/index.jsx": 9227,
	"./components/Finance/styles": 5212,
	"./components/Finance/styles.js": 5212,
	"./components/FoodAppConstants": 549,
	"./components/FoodAppConstants.js": 549,
	"./components/Home": 7469,
	"./components/Home/": 7469,
	"./components/Home/index": 7469,
	"./components/Home/index.jsx": 7469,
	"./components/Home/styles": 131,
	"./components/Home/styles.js": 131,
	"./components/Layout": 2111,
	"./components/Layout.js": 2111,
	"./components/Loader": 5395,
	"./components/Loader/": 5395,
	"./components/Loader/index": 5395,
	"./components/Loader/index.jsx": 5395,
	"./components/Login": 4221,
	"./components/Login/": 4221,
	"./components/Login/index": 4221,
	"./components/Login/index.jsx": 4221,
	"./components/Login/styles": 3129,
	"./components/Login/styles.js": 3129,
	"./components/Logout": 9648,
	"./components/Logout/": 9648,
	"./components/Logout/index": 9648,
	"./components/Logout/index.jsx": 9648,
	"./components/Menu": 9483,
	"./components/Menu/": 9483,
	"./components/Menu/index": 9483,
	"./components/Menu/index.jsx": 9483,
	"./components/MenuCard": 4429,
	"./components/MenuCard/": 4429,
	"./components/MenuCard/index": 4429,
	"./components/MenuCard/index.jsx": 4429,
	"./components/MyLocation/Index": 1361,
	"./components/MyLocation/Index.jsx": 1361,
	"./components/MyOrders": 5307,
	"./components/MyOrders/": 5307,
	"./components/MyOrders/index": 5307,
	"./components/MyOrders/index.jsx": 5307,
	"./components/Navbar": 9587,
	"./components/Navbar/": 9587,
	"./components/Navbar/index": 9587,
	"./components/Navbar/index.jsx": 9587,
	"./components/Navbar/styles": 1780,
	"./components/Navbar/styles.js": 1780,
	"./components/RequireAuth": 6720,
	"./components/RequireAuth.js": 6720,
	"./components/SearchBar/Index": 7199,
	"./components/SearchBar/Index.jsx": 7199,
	"./components/Sidebar": 1394,
	"./components/Sidebar/": 1394,
	"./components/Sidebar/SidebarData": 5032,
	"./components/Sidebar/SidebarData.js": 5032,
	"./components/Sidebar/index": 1394,
	"./components/Sidebar/index.jsx": 1394,
	"./components/Sidebar/styles": 8290,
	"./components/Sidebar/styles.js": 8290,
	"./components/UserOrders": 4384,
	"./components/UserOrders/": 4384,
	"./components/UserOrders/index": 4384,
	"./components/UserOrders/index.jsx": 4384,
	"./components/VendorCard": 2664,
	"./components/VendorCard/": 2664,
	"./components/VendorCard/index": 2664,
	"./components/VendorCard/index.jsx": 2664,
	"./components/VendorOrders": 8671,
	"./components/VendorOrders/": 8671,
	"./components/VendorOrders/index": 8671,
	"./components/VendorOrders/index.jsx": 8671,
	"./components/Vendors": 1671,
	"./components/Vendors/": 1671,
	"./components/Vendors/index": 1671,
	"./components/Vendors/index.jsx": 1671,
	"./hooks/mediaquery": 823,
	"./hooks/mediaquery.js": 823,
	"./hooks/outsideClickAlerter": 3417,
	"./hooks/outsideClickAlerter.js": 3417,
	"./hooks/useScrollToTop": 5025,
	"./hooks/useScrollToTop.js": 5025,
	"./index": 5915,
	"./index.js": 5915,
	"./logo.svg": 9445,
	"./redux/feature/authSlice": 5652,
	"./redux/feature/authSlice.js": 5652,
	"./redux/feature/billingSlice": 1953,
	"./redux/feature/billingSlice.js": 1953,
	"./redux/feature/cartSlice": 7020,
	"./redux/feature/cartSlice.js": 7020,
	"./redux/feature/menuSlice": 743,
	"./redux/feature/menuSlice.js": 743,
	"./redux/feature/orderSlice": 956,
	"./redux/feature/orderSlice.js": 956,
	"./redux/feature/rootReducer": 7148,
	"./redux/feature/rootReducer.js": 7148,
	"./redux/feature/uiSlice": 680,
	"./redux/feature/uiSlice.js": 680,
	"./redux/feature/vendorSlice": 7072,
	"./redux/feature/vendorSlice.js": 7072,
	"./redux/store": 5580,
	"./redux/store.js": 5580,
	"./reportWebVitals": 9031,
	"./reportWebVitals.js": 9031,
	"./reusable/Table/Table": 9059,
	"./reusable/Table/Table.js": 9059,
	"./reusable/Table/style": 6446,
	"./reusable/Table/style.js": 6446,
	"./saga/authSaga": 7127,
	"./saga/authSaga.js": 7127,
	"./saga/menuSaga": 1966,
	"./saga/menuSaga.js": 1966,
	"./saga/orderSaga": 2317,
	"./saga/orderSaga.js": 2317,
	"./saga/rootSaga": 1081,
	"./saga/rootSaga.js": 1081,
	"./saga/vendorSaga": 1031,
	"./saga/vendorSaga.js": 1031,
	"./styles/globalStyles": 7222,
	"./styles/globalStyles.js": 7222,
	"./styles/standardGrids.js/Grid": 1499,
	"./styles/standardGrids.js/Grid.js": 1499,
	"./styles/theme": 8114,
	"./styles/theme.js": 8114,
	"./styles/variables": 2558,
	"./styles/variables.js": 2558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;